








































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { LMap, LMarker, LPopup, LTileLayer, LIcon, LControl, LCircleMarker } from 'vue2-leaflet'
import { Lantern } from '../../../mj-energy-operator/src/models'
import { Action, Mutation, State } from 'vuex-class'
import { MapBounds } from '@/types'

  @Component({
    components: {
      LMap,
      LTileLayer,
      LMarker,
      LPopup,
      LIcon,
      LControl,
      LCircleMarker
    }
  })
export default class Map extends Vue {
    @Prop({ default: [] }) private lanterns!: Array<Lantern>

    @Action('lanterns/loadLanterns')
    loadLanterns!: (bounds?: MapBounds) => {}

    @Mutation('lanterns/clearLanterns')
    clearLanterns!: () => {}

    @Mutation('updateZoom')
    updateZoomMutation!: (zoom: number) => {}

    @Mutation('updateCenter')
    updateCenterMutation!: (center: Array<number>) => {}

    @Mutation('updateMapBounds')
    updateMapBoundsMutation!: (bounds: MapBounds) => {}

    @State('zoom')
    private zoom!: number

    @State('mapCenter')
    private mapCenter!: Array<number>

    private showLanterns = false

    mounted () {
      const map = this.$refs.map as LMap
      // ugly trick to pass that value without changing the type
      this.updateZoom(this.zoom)
      this.updateBounds(map.mapObject.getBounds() as unknown as MapBounds)
    }

    updateZoom (zoom: number) {
      if (this.zoom !== zoom) {
        this.updateZoomMutation(zoom)
      }
      this.showLanterns = this.zoom > 16
    }

    updateCenter (center: Array<number>) {
      if (this.mapCenter !== center) {
        this.updateCenterMutation(center)
      }
    }

    updateBounds (bounds: MapBounds) {
      if (this.showLanterns) {
        this.updateMapBoundsMutation(bounds)
        this.loadLanterns(bounds)
      } else {
        this.clearLanterns()
      }
    }
}
